import L from 'leaflet';

const Control = L.Control.extend({
  initialize: function (options) {
    for (let i in options) {
      if (i === 'id') {
        this.id = options.id
      } else if (i[0] === '_') {
        this[i] = options[i]
      } else {
        this.options[i] = options[i]
      }
    }
  },
  addTo: function (map) {
    this.remove()
    this._map = map

    const container = this._container = this.onAdd(map),
        pos = this.getPosition(),
        corner = map._controlCorners[pos];

    container.classList.add('leaflet-control')

    if (pos.indexOf('bottom') !== -1) {
      corner.insertBefore(container, corner.firstChild)
    } else {
      corner.appendChild(container);
    }

    if (this.mounted) {
      this.mounted()
    }


    map.on('unload', this.remove, this)
    map.customControls[this.id] = this
    map._resizeControls()
    return this
  },
  remove: function () {
    if (!this._map) {
      return this
    }

    const parent = this._container.parentNode
    if (parent) {
      parent.removeChild(this._container)
    }

    if (this.onRemove) {
      this.onRemove(this._map)
    }

    this._map.off('unload', this.remove, this)
    this._map._resizeControls()
    this._map = null
    return this
  },
})

L.extend(Control.prototype, L.Evented.prototype)

export default Control